import { useEffect } from 'react';

export default function GoogleTagManager() {
	useEffect(() => {
		(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
			const f = d.getElementsByTagName(s)[0],
				j = d.createElement(s) as HTMLScriptElement,
				dl = l !== 'dataLayer' ? '&l=' + l : '';
			j.async = true;
			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
			f.parentNode!.insertBefore(j, f);
		})(window, document, 'script', 'dataLayer', 'GTM-T9D3FKJ');
	}, []);

	return (
		<noscript>
			<iframe
				title="Google Analytics"
				src="https://www.googletagmanager.com/ns.html?id=GTM-T9D3FKJ"
				height="0"
				width="0"
				style={{ display: 'none', visibility: 'hidden' }}
			></iframe>
		</noscript>
	);
}
